<script lang="ts">
  import setInitialTheme from '../utils/setInitialThemeRaw.ts?raw'

  // eslint-disable-next-line no-useless-escape
  const setInitialThemeScript = `<script>${setInitialTheme}<\/script>`
</script>

<!--eslint-disable-next-line svelte/no-at-html-tags-->
{@html setInitialThemeScript}
